import { AlLocatorService, AIMSClient } from "@al/core";
import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
@Component({
  selector: 'reset-confirmation',
  templateUrl: './reset-confirmation.component.html',
  styleUrls: [ './reset-confirmation.component.scss' ]
})

export class ResetConfirmationComponent implements AfterViewInit {

    public emailAddress:string;
    public oldPassword:string;
    public newPassword:string;
    public confirmPassword:string;
    public state:string = "change";
    public errorMessage:string = "";
    public returnUrl:string;

    public showOldPassword: boolean = false;
    public showNewPassword: boolean = false;
    public showConfirmNewPassword: boolean = false;

    constructor( public router:Router,
                 private activatedRoute: ActivatedRoute ) {
    }

    ngAfterViewInit() {
        this.initialize();
    }

    initialize() {
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.emailAddress = params['email'];
            this.returnUrl    = params['return_to'];
            if (!this.emailAddress) {
                this.state = "error";
                this.errorMessage = "Invalid parameters";
            }
        });
    }

    /** When user click on the change password button */
    onSubmit = async () => {
        this.state = "loading";
        if (!this.emailAddress) {
            this.manageErrors("Invalid email");
            return
        }

        if (!this.oldPassword) {
            this.manageErrors("Invalid oldPassword");
            return
        }

        if (!this.newPassword) {
            this.manageErrors("Invalid newPassword");
            return
        }
        try {
            await AIMSClient.changePassword(this.emailAddress, this.oldPassword, this.newPassword);
            this.state = "done";
            this.closeMessageError();
        } catch (error) {
            this.state       = "change";
            this.manageErrors(error.data.error);
        }
    }

    /** When user click on the return to login button */
    onReturnToLogin = () => {
        window.location.href = this.returnUrl ? this.returnUrl : AlLocatorService.resolveURL( "cd17:accounts", "" );
    }

    /** Toggle show old password */
    toggleShowOldPassword = () => {
        this.showOldPassword = !this.showOldPassword
    }

    /** Toggle show new password */
    toggleShowNewPassword = () => {
        this.showNewPassword = !this.showNewPassword
    }

    /** Toggle show confirm new password */
    toggleShowConfirmNewPassword = () => {
        this.showConfirmNewPassword = !this.showConfirmNewPassword
    }

    /** Manage the errors */
    manageErrors = ( error:string ) => {
        let message = "An internal error occurred while saving your information. Please try again.";

        if (error === 'weak_password') {
            message = "You must choose a strong password. Please review our password policy and try again.";
        }else if (error === 'password_reuse_prevented') {
            message = "Cannot update user information, because the password was already used.";
        }else if (error === 'Unauthorized') {
            message = "Alert Logic could not authenticate your credentials.";
        }

        this.showErrorMsg(message);
    }

    /** Show an error message */
    showErrorMsg = ( msg:any ) => {
        // TODO: replace this for the notification panel
        this.errorMessage = msg;
    }

    /** Close error message */
    closeMessageError = () => {
        this.errorMessage = "";
    }
}
